import { render, staticRenderFns } from "./SeniorOrdersCrs.vue?vue&type=template&id=16b45d8e&scoped=true&"
import script from "./SeniorOrdersCrs.vue?vue&type=script&lang=js&"
export * from "./SeniorOrdersCrs.vue?vue&type=script&lang=js&"
import style0 from "./SeniorOrdersCrs.vue?vue&type=style&index=0&id=16b45d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b45d8e",
  null
  
)

export default component.exports